import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {Session} from "../../../services/Session";
import {ModelBasedNumeral} from "../../../directives/model-numeral";
import {TpiqCustomDatepicker} from "../../../directives/tpiq-custom-datepicker";

declare const _: any;

@Component({
  selector: 'app-plan-strategy-tasks',
  standalone: true,
  imports: [CommonModule, FormsModule, ModelBasedNumeral, TpiqCustomDatepicker],
  templateUrl: './plan-strategy-tasks.component.html',
  styleUrl: './plan-strategy-tasks.component.scss'
})
export class PlanStrategyTasksComponent implements OnInit, OnDestroy {
  org: string = Session.getOrg();
  user: any = {};
  @Input() tasks: any;
  @Input() client: any;
  @Input() plan: any;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('tasksInfo', { static: true }) tasksInfo!: TemplateRef<any>;

  constructor(
    private viewContainerRef: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this.viewContainerRef.createEmbeddedView(this.tasksInfo);
    this.user = Session.getUser();
  }

  ngOnDestroy(): void {
    this.viewContainerRef.clear();
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  setDueDate($event, task){
    task.dueDate = $event;
  }

}
